<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="wizard row m-none " [class]="class">

  <div class="wizard-menu col-12 col-md-3" [ngClass]="{'d-none': !showMenu}">
    <ul>
      <li *ngFor="let tab of tabs; index as i; last as isLast"
          (click)="((isEdit || activeIndex > i) && !disabledSteps[i]) ? setIndex(i) : null"
          [ngClass]="{active: activeIndex===i, last: isLast, clickable: ((isEdit || activeIndex > i) && !disabledSteps[i])}">
        <span class="number"> {{i + 1}} </span>
        {{ tab.label }}
      </li>
    </ul>
  </div>

  <div class="wizard-content col-12 p-none full-height" [ngClass]="{'col-md-9': showMenu}">

    <div *ngFor="let tab of tabs; let i = index" class="tab-panel" [ngClass]="{'display': activeIndex === i}">
      <div class="card full-height m-none" *ngIf="activeIndex === i">
        <ng-container *ngTemplateOutlet="tab.template ?? null"></ng-container>
      </div>
    </div>

  </div>

</div>



